export default __webpack_public_path__ + "static/media/rust-logo-white.b4b3ffe2.png";